import React from 'react';

export interface IScrollTopContext {
  scrollTop: number;
  scrollLeft: number;
}

export const ScrollTopContext = React.createContext<IScrollTopContext>({
  scrollTop: 0,
  scrollLeft: 0,
});

export function useScrollPosition() {
  const scrollPosition = React.useContext(ScrollTopContext);

  return scrollPosition;
}
